import {observer} from "mobx-react-lite";
import {useEffect} from "react";
import clubStore from "../../../storage/ClubStore";
import Debts from "../ParentMember/Debts";

const ParentDebts = () => {
    const parent = clubStore.parent;

    useEffect(() => {
        if (!parent.company_id || !parent.child_id) {
            parent.setProperty("debts", []);
            return;
        }
        parent.getDebts();
    }, [parent.company_id, parent.child_id]);

    return <Debts debts={parent.debts} url="/parent/children/billing"/>;
};

export default observer(ParentDebts);
